// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__2WZRa","tabs_wrapper":"styles_tabs_wrapper__2Nqlk","tab":"styles_tab__2EoyT","active":"styles_active__XFmKs"};